import React, { useState } from 'react';
import { FaUserPlus, FaUserMinus, FaExclamationCircle } from 'react-icons/fa';
import './StaffCell.css';
import { useRoster } from './hooks/useRoster';

export const StaffCell = ({
  staff,
  date,
  shiftId,
  showActions = false,
  compact = false
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    activeStaff,
    removeStaffFromShift,
    assignStaffToShift,
    isStaffOnLeave
  } = useRoster();

  const handleRemoveStaff = () => {
    if (staff) {
      removeStaffFromShift(staff.id, shiftId, date);
    }
    setIsOpen(false);
  };

  const handleAssignStaff = (staffMember) => {
    const success = assignStaffToShift(staffMember.id, shiftId, date);
    if (!success) {
      console.log('Cannot assign staff - they are on leave');
    }
    setIsOpen(false);
  };

  if (!staff) {
    if (!showActions) {
      return (
        <div className={`staffcell-empty ${compact ? 'compact' : ''}`}>
          <span className="text-xs text-muted">Empty</span>
        </div>
      );
    }

    return (
      <div className={`staffcell-popover-trigger ${compact ? 'compact' : ''}`}>
        <button
          className="btn-icon dashed"
          onClick={() => setIsOpen(true)}
          title="Assign Staff"
        >
          <FaUserPlus className="icon-primary" />
        </button>

        {isOpen && (
          <div className="popover-content">
            <div className="popover-header">
              <h4>Assign Staff</h4>
            </div>
            <div className="popover-list">
              {activeStaff
                .filter(s => !isStaffOnLeave(s.id, date))
                .map(staffMember => (
                  <button
                    key={staffMember.id}
                    className="popover-item"
                    onClick={() => handleAssignStaff(staffMember)}
                  >
                    <div className="item-avatar">
                      {staffMember.name.split(' ').map(n => n[0]).join('')}
                    </div>
                    <div className="item-info">
                      <div className="item-name">{staffMember.name}</div>
                      <div className="item-position">{staffMember.position}</div>
                    </div>
                  </button>
                ))}

              {activeStaff.filter(s => !isStaffOnLeave(s.id, date)).length === 0 && (
                <div className="popover-empty">
                  No available staff for this date
                </div>
              )}
              <button className="popover-close" onClick={() => setIsOpen(false)}>
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }

  const onLeave = isStaffOnLeave(staff.id, date);

  return (
    <div
      className={`staffcell ${compact ? 'compact' : ''} ${
        onLeave ? 'on-leave' : ''
      }`}
    >
      <div className={`avatar ${compact ? 'avatar-small' : ''}`}>
        {staff.name.split(' ').map(n => n[0]).join('')}
      </div>
      <div className={`staff-info ${compact ? 'info-compact' : ''}`}>
        <div className={`staff-name ${compact ? 'name-compact' : ''}`}>
          {compact ? staff.name.split(' ')[0] : staff.name}
        </div>
        {!compact && (
          <div className="staff-position">
            {staff.position}
          </div>
        )}
      </div>
      {onLeave && (
        <FaExclamationCircle className={`icon-leave ${compact ? 'icon-small' : 'icon'}`} title="On Leave" />
      )}
      {showActions && !compact && (
        <button
          className="btn-icon small"
          onClick={handleRemoveStaff}
          title="Remove from Shift"
        >
          <FaUserMinus className="icon-small" />
        </button>
      )}
    </div>
  );
};
